import { VehicleImageWithMeta } from '../../types/vehicle';
import { isEmpty } from 'lodash-es';

const interiorCategories = ['360int', 'Interior'];
const heroImageType = 'Exterior_0';

const sortBySequence = (a: VehicleImageWithMeta, b: VehicleImageWithMeta) =>
  a.sequence - b.sequence;

interface ParsedImages {
  interiorImages: VehicleImageWithMeta[];
  exteriorImages: VehicleImageWithMeta[];
  galleryImages: VehicleImageWithMeta[];
  heroImage?: VehicleImageWithMeta;
}

export default function assembleInteriorExteriorImageBuckets(
  images: VehicleImageWithMeta[]
): ParsedImages {
  const parsedImages: ParsedImages = {
    interiorImages: [],
    exteriorImages: [],
    galleryImages: [],
    heroImage: undefined,
  };

  // Filter and process valid images
  for (const image of images) {
    // Skip invalid images
    if (
      isEmpty(image.path) ||
      isEmpty(image.available_format) ||
      isEmpty(image.image_type) ||
      isEmpty(image.image_category) ||
      // Since sequence 0 is valid, we need to check for undefined or null
      image.sequence === undefined ||
      image.sequence === null
    ) {
      continue;
    }

    if (image.image_type === heroImageType) {
      parsedImages.heroImage = image;
      continue;
    }

    parsedImages.galleryImages.push(image);

    if (interiorCategories.includes(image.image_category)) {
      parsedImages.interiorImages.push(image);
    } else {
      parsedImages.exteriorImages.push(image);
    }
  }

  parsedImages.interiorImages.sort(sortBySequence);
  parsedImages.exteriorImages.sort(sortBySequence);

  // Sort gallery images: non-interior first, then interiors, both sorted by sequence
  parsedImages.galleryImages.sort((a, b) => {
    const aIsInterior = interiorCategories.includes(a.image_category);
    const bIsInterior = interiorCategories.includes(b.image_category);

    if (aIsInterior !== bIsInterior) {
      return aIsInterior ? 1 : -1; // Non-interior images come first
    }

    // Within the same category, sort by sequence
    return a.sequence - b.sequence;
  });

  return parsedImages;
}
